import { MqttService } from '@autopass-web/domain';
import { barcodePaymentMqttAction } from '@autopass-web/feature-barcode-payment';

import { getLoginState } from '../utils/login-state';
import repository from './repository';

const mqtt = new MqttService();

export const connectMQTT = (appStore, { client, password }) => {
  const loginState = getLoginState();

  const checkLatestRefuelingRequest = async () => {
    if (loginState === 'user') {
      const { error, data } = await repository.fetchRefuelingRequestsLatest();

      if (error) return appStore.setToastMessage('加油要求失敗，請重新嘗試');

      if (
        appStore.refuelingRequest === null &&
        !appStore.isRefuelingRequestProcessing &&
        data
      ) {
        appStore.setRefuelingRequest(data);
      }
    }
  };

  checkLatestRefuelingRequest();

  mqtt.setClient(client);
  mqtt.setPassword(password);
  mqtt.connect();

  mqtt.onActionCallBack = (mqttAction) => {
    const mqttActionGroup = {
      approve_payment_request: (mqttAction) => {
        switch (mqttAction.action) {
          case 'create':
            checkLatestRefuelingRequest();
            break;
          case 'cancel':
            appStore.setRefuelingRequest(null);
            appStore.setToastMessage('此交易授權已由店家取消');
            appStore.toggleToastMessage();
            break;
          default:
            return '';
        }
      },
      ...barcodePaymentMqttAction,
    };

    let mqttRequest = mqttActionGroup[mqttAction.type];
    mqttRequest(mqttAction);
  };
};
